export const defaultSEO = {
  title: 'GreenLens - Identify Any Plant Instantly',
  description:
    'Upload a photo or take a picture to instantly identify plants, get care instructions, and learn more about your flora. Free, fast, and accurate plant identification powered by AI.',
  keywords: [
    'plant identification',
    'GreenLens',
    'plant recognition',
    'plant species',
    'garden plants',
    'houseplants',
    'plant care',
    'botany',
    'plant app',
    'AI plant identification'
  ].join(', '),
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: 'https://plant-identifier-wheat.vercel.app/',
    siteName: 'GreenLens',
    images: [
      {
        url: 'https://images.unsplash.com/photo-1520412099551-62b6bafeb5bb?auto=format&fit=crop&q=80',
        width: 1200,
        height: 630,
        alt: 'GreenLens'
      }
    ]
  }
};
